import { render, staticRenderFns } from "./HomeBranding.vue?vue&type=template&id=56f6763a&"
import script from "./HomeBranding.vue?vue&type=script&lang=js&"
export * from "./HomeBranding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports